import type { FieldDef } from '@jfh/intake-shared';
import { Field } from './Field.js';
import { companyStatusLine } from './lib/company.js';
import { vatStatusLine } from './lib/vat.js';
import { asAddress } from './lib/steps.js';
import type { ApplicantForm } from './useApplicantForm.js';

/** The visible questions of one page, as live inputs. */
export function StepFields({ flow, fields }: { flow: ApplicantForm; fields: FieldDef[] }) {
  // The first address field on the whole form — later address fields can copy it.
  const addressFields = flow.form.fields.filter((f) => f.type === 'address');
  const firstAddressId = addressFields[0]?.id;
  const firstAddressLabel = addressFields[0]?.label ?? 'the first address';

  return (
    <div className="rdr-fields">
      {fields
        .filter((f) => flow.vis[f.id])
        .map((f) => (
          <Field
            key={f.id}
            field={f}
            value={flow.values[f.id]}
            onChange={(v) => flow.setValue(f.id, v)}
            error={flow.errors[f.id]}
            firstAddress={
              firstAddressId &&
              ((f.type === 'address' && f.id !== firstAddressId) || f.type === 'contact')
                ? asAddress(flow.values[firstAddressId])
                : undefined
            }
            firstAddressLabel={firstAddressLabel}
            countries={flow.countries}
            defaultCountryIso={flow.defaultCountryIso}
            locked={flow.locked.has(f.id)}
            lookupStatus={
              f.type === 'company_number'
                ? companyStatusLine(flow.companies[f.id])
                : f.type === 'vat' && flow.checksVat
                  ? vatStatusLine(flow.values[f.id], flow.vats[f.id])
                  : null
            }
          />
        ))}
    </div>
  );
}
